import React from 'react';

export default function Photos() {
  const albums = [
    {
      title: "Occupational Health & Safety",
      thumbnail: "https://live.staticflickr.com/65535/54093851445_ec43e7c0dc_z.jpg",
      link: "https://www.flickr.com/photos/201676543@N02/albums/72177720321486655"
    }
    // Add more albums here if needed
  ];

  return (
    <div className="p-8 mt-24 text-center">
      <h1 className="text-2xl font-semibold mb-6">Gallery</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {albums.map((album, index) => (
          <div key={index} className="album-card">
            <a
              href={album.link}
              title={album.title}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <img
                src={album.thumbnail}
                alt={album.title}
                className="w-full h-auto rounded-lg shadow-md hover:opacity-90 transition duration-300"
              />
              <p className="mt-2 text-lg font-medium text-gray-700">{album.title}</p>
            </a>
          </div>
        ))}
      </div>
      <script async src="//embedr.flickr.com/assets/client-code.js" charset="utf-8"></script>
    </div>
  );
}
